import React from "react";
import { Loader, Text } from "@mantine/core";

interface LoadingScreenProps {
  message?: string;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({
  message = "Loading...",
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        gap: 16,
      }}
    >
      <Loader size={48} />
      <Text size="lg" c="dimmed">
        {message}
      </Text>
    </div>
  );
};
